<template>
  <div v-if="questionairAttended">
    <Summary :response="responses" :question="questions" />
  </div>
  <div id="questionAnswer" class="section is-small" v-else>
    <div v-if="isLoading">
      Loading...
      <i class="fa fa-spinner fa-2x"></i>
    </div>
    <div v-else>
      <progress class="progress is-success" :value="progressPercent" max="100"></progress>
      <div class="is-size-6 has-text-centered">{{ quesInfo }}</div>
      <br />
      <div class="is-size-6 has-text-centered">
        <b>{{ question }}</b>
      </div>
      <br />
      <div class="columns is-multiline is-mobile" v-if="!isSubQuestion">
        <div class="column is-6 has-text-centered is-outlined" v-for="(option, index) in options" :key="`o${index}`">
          <a class="button" v-on:click="updateResponse(index)">{{ option }}</a>
        </div>
      </div>
      <div class="columns is-multiline is-mobile" v-else>
        <div class="column is-6 has-text-centered is-outlined" v-for="(option, index) in options" :key="`o1${index}`">
          <a class="button disable" disabled>{{ option }}</a>
        </div>
      </div>
      <!-- subquestion display -->
      <div class="card column" v-if="isSubQuestion">
        <div class="is-size-6 has-text-centered">
          <b>{{ subQuestion }}</b>
        </div>
        <br />
        <div class="columns is-multiline is-mobile">
          <div class="column is-6 has-text-centered is-outlined" v-for="(option, index) in subOptions" :key="`o2${index}`">
            <a class="button" v-on:click="updateResponseSubQuestion(index)">{{ option }}</a>
          </div>
        </div>
      </div>
      <br />
      <div class="columns is-gapless is-mobile">
        <div class="column has-text-centered">
          <a class="tc-button has-text-centered notification is-normal" :disabled="index <= 0" @click="showPrevQuesOptions(index - 1)">&lt; Previous</a>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import Summary from './Summary';

export default {
  name: 'tests',
  components: {
    Summary,
  },
  data() {
    return {
      index: 0,
      isLoading: true,
      progressPercent: 0,
      questions: [],
      question: '',
      options: [],
      quesInfo: '',
      responses: [],
      questionairAttended: false,
      isSubQuestion: false,
      subOptions: [],
      subQuestion: '',
    };
  },
  methods: {
    setInitialQuesOptions() {
      this.question = this.questions[0].question;
      this.options = this.questions[0].options;
      this.quesInfo = this.questions[0].qInfo;
    },
    setQuestionsDatas(index) {
      this.question = this.questions[index].question;
      this.options = this.questions[index].options;
      this.quesInfo = this.questions[index].qInfo;
    },
    setNextQuesAndOptions(index) {
      this.index = index;
      this.setQuestionsDatas(this.index);
      this.updateProgress();
      this.scrollToQuestion();
    },
    fetchQuestions() {
      this.$http
        .get('/scarf/getQuestions', {
          params: { qId: this.$temp.testId },
        })
        .then((res) => {
          this.isLoading = false;
          this.questions = res.data.questions;
          console.log(this.questions);
          this.setInitialQuesOptions();
        });
    },
    updateProgress() {
      const progress = (100 * this.index) / this.questions.length;
      this.progressPercent = parseInt(progress, 10);
    },
    scrollToQuestion() {
      window.scroll(0, 0);
    },
    showQuestion(index) {
      console.log('question: ', index);
      if (index < 0) {
        return;
      }
      if (index >= this.questions.length) {
        this.questionairAttended = true;
        return;
      }
      this.setNextQuesAndOptions(index);
    },
    isOddIndex(index) {
      if (index % 2 === 0) {
        return false;
      }
      return true;
    },
    showPrevQuesOptions(index) {
      if (index < 0) {
        return;
      }
      if (index >= this.questions.length) {
        this.questionairAttended = true;
        return;
      }
      this.index = index;
      if (this.index > 15 && this.isOddIndex(this.index)) {
        if (this.responses[this.index - 1].idx === 0) {
          this.index = index - 1;
          this.isSubQuestion = false;
          this.setQuestionsDatas(this.index);
        } else {
          this.setQuestionsDatas(this.index - 1);
          this.isSubQuestion = true;
          this.subQuestion = this.questions[this.index].question;
          this.subOptions = this.questions[this.index].options;
        }
      } else {
        this.isSubQuestion = false;
        this.setQuestionsDatas(this.index);
      }
      this.updateProgress();
      this.scrollToQuestion();
    },
    updateResponse(optionIndex) {
      this.responses[this.index] = { idx: optionIndex };
      if (this.index + 1 < this.questions.length) {
        if (this.index > 15 && this.isOddIndex(this.index + 1)) {
          if (optionIndex === 0) {
            this.index = this.index + 1;
            this.isSubQuestion = false;
            this.responses[this.index] = { idx: 0 };
          } else {
            console.log('subquestion');
            this.isSubQuestion = true;
            this.subQuestion = this.questions[this.index + 1].question;
            this.subOptions = this.questions[this.index + 1].options;
            return;
          }
        }
      }
      this.showQuestion(this.index + 1);
      console.log(this.responses);
    },
    updateResponseSubQuestion(optionIndex) {
      this.isSubQuestion = false;
      this.index = this.index + 1;
      this.responses[this.index] = { idx: optionIndex };
      this.showQuestion(this.index + 1);
      console.log(this.responses);
    },
  },
  created() {
    if (this.$temp.sessionCode) {
      this.fetchQuestions();
    } else {
      this.$toast.open('Your session ended. Enter your organization code and try again.');
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
.progress {
  padding-left: 0px;
  height: 10px;
}
.section {
  padding: 3px;
  margin-left: 0px;
  margin-right: 0px;
  overflow-x: hidden;
}
.disable {
  color: #a9a9a9;
}
.button {
  border: 1px solid #a9a9a9;
  line-height: 1.5em;
  height: 75px;
  width: 145px;
  white-space: initial;
}
.tc-button {
  border: 1px solid #a9a9a9;
  height: 10px;
  width: 160px;
  padding: 10px 10px 10px 10px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Tests.vue